

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
import index from '@/filter';

@Component({
  components: { SafetyAndEnvironmentDialog },
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  @Prop(String) rowTitle!: any; // 传递给编辑页面-数据对象
  @Prop(String) rowAssessType!: any; // 传递给编辑页面-数据对象

  private titleContent: any = '';
  private newIndex: any = '';
  private newList: any = [];

  // 职务
  assessScoreOptions: any = [
    {
      value: 1,
      label: '加分',
    },
    {
      value: 0,
      label: '扣分',
    },
  ];
  // 表单数据
  formData: any = {};

  formRules: any = {};

  private assessStandConfigOptions: any = []; // 考核项目展示列表

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.titleContent = this.rowTitle; // 标题
    // // 获取分页数据
    this.getAssessStandConfigSearch(this.rowAssessType);
    this.getPageData();
  }

  changeProject(type: any, index: any) {
    this.newIndex = index;
    if (type) {
      const safetyDialog = 'safetyDialog';
      const safetyDialogComponent = this.$refs[safetyDialog];
      (safetyDialogComponent as any).showDialog(type); // 传给弹窗的数据 检查标准项(即 检查内容)
    } else {
      this.$message.warning('请先选择考核类型！');
    }
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    // console.log(this.newIndex);
    if (data) {
      this.formData[this.newIndex].adjustAssessProject = data.assessProject;
      this.formData[this.newIndex].adjustAssessContent = data.assessContent;
      this.formData[this.newIndex].adjustAssessStand = data.assessStand;
    } else {
      this.formData[this.newIndex].adjustAssessProject = '';
      this.formData[this.newIndex].adjustAssessContent = '';
      this.formData[this.newIndex].adjustAssessStand = '';
    }

    this.$forceUpdate();
  }

  getNameById(id: any) {
    let a: any = '';
    this.assessStandConfigOptions.forEach((re: any) => {
      if (re.id === id) {
        return (a = re.assessProject);
      }
      return a;
    });
    return a;

    //   const obj: any = this.assessStandConfigOptions.find((obj: any) => {
    //     return obj.id === id;
    //   });
    // console.log(obj)
    //   return obj.assessProject;
  }

  getAssessStandConfigSearch(data: any) {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getAssessStandConfigAll({ assessType: data })
      .then((res: any) => {
        this.assessStandConfigOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  getAssessStandConfig(data: any) {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer.getAssessStandConfigAll({ assessType: data }).then((res: any) => {
      this.newList = res.data;
    });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getReportViewAllData(this.row.id)
      .then((res: any) => {
        // res.data.map((resInner: any, index: any) => {
        //   this.getAssessStandConfig(resInner.assessType);
        //   // setTimeout(() => {
        //     resInner.newList = this.newList;
        //   // }, 100);
        // });
        // setTimeout(() => {

        res.data.map((resInner: any) => {
          resInner.adjustPointsFlag = resInner.adjustPointsFlag === true ? 1 : 0;
        });
        this.formData = res.data;
        // }, 300);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });

    this.$forceUpdate();
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  /**
   * @desc 点击取消按钮
   */
  save() {
    safetyAndEnvironmentAssessmentServer
      .editInnerViewDetailsData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功');
          this.close();
        } else {
          this.$message.error(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('编辑失败');
      });
  }
}
